import type { Enums } from "@msuite/utils/types";
import { enumeration, number, string, table } from "@rocicorp/zero";

/**
 * What became of one dropped file, on the sync path because its row changes without the browser
 * doing anything: a worker reads the file, asks where it belongs, and writes the answer. Nothing
 * else would tell the pill at the bottom of the window, which is the only place the drop is
 * reported at all.
 *
 * Read-only from here — no mutator writes it. The columns are what the pill renders and no more,
 * which is why `candidates`, `targetKeys` and `error` are absent: the first two are a model's
 * working and the third is a stack trace's neighbour, and all three belong to the inbox page,
 * which fetches them over the API against the caller's `read File` rule.
 */
export const fileClassification = table("fileClassifications")
	.from("file_classifications")
	.columns({
		id: string(),
		orgId: string().from("org_id"),
		// The upload id the drop produced, and the same value as the files' `directory`. It is
		// duplicated onto this row on purpose: the pill's query is then a single-table root with
		// one organisation clause, rather than a join it would have to scope hop by hop.
		batchId: string().from("batch_id"),
		fileId: string().from("file_id"),
		state: enumeration<Enums<"fileClassificationState">>(),
		// Nullable in the database, because the column is ON DELETE SET NULL. The query compares it
		// against the caller, so a row that has lost its author reaches nobody — which is right:
		// a batch is only ever watched by the person who dropped it, and that person is gone.
		createdBy: string().from("created_by").optional(),
		createdAt: number().from("created_at"),
	})
	.primaryKey("id");
